"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immer_1 = __importDefault(require("immer"));

var react_1 = require("react");

function useMethods(methods, initialState) {
  var reducer = react_1.useMemo(function () {
    return immer_1.default(function (state, action) {
      var _a;

      return (_a = methods(state))[action.type].apply(_a, action.payload);
    });
  }, [methods]);

  var _a = react_1.useReducer(reducer, initialState),
      state = _a[0],
      dispatch = _a[1];

  var actionTypes = Object.keys(methods(initialState));
  var callbacks = react_1.useMemo(function () {
    return actionTypes.reduce(function (accum, type) {
      accum[type] = function () {
        var payload = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          payload[_i] = arguments[_i];
        }

        return dispatch({
          type: type,
          payload: payload
        });
      };

      return accum;
    }, {});
  }, actionTypes);
  return [state, callbacks];
}

exports.default = useMethods;